// Guardados en fila por clave: dos seguidos llegan a la base en el orden en que se pidieron (el último gana),
// y quien relee la base puede esperar a que terminen los pendientes (review Greptile #156: "Publicar" leía la
// ficha mientras un guardado seguía en camino).

export interface FilaDeGuardados {
  encolar<T>(clave: string, escribir: () => Promise<T>): Promise<T>;
  /** Espera los guardados que están en camino ahora (los fallidos también cuentan como terminados). */
  esperarTodo(): Promise<void>;
}

export function crearFilaDeGuardados(): FilaDeGuardados {
  const colas = new Map<string, Promise<unknown>>();
  return {
    encolar(clave, escribir) {
      const anterior = colas.get(clave) ?? Promise.resolve();
      const turno = anterior.catch(() => undefined).then(escribir);
      const cola = turno.catch(() => undefined);
      colas.set(clave, cola);
      void cola.then(() => {
        if (colas.get(clave) === cola) colas.delete(clave);
      });
      return turno;
    },
    async esperarTodo() {
      await Promise.allSettled([...colas.values()]);
    },
  };
}
